export default "__VITE_ASSET__8c293f30__"